@if (order$ | async; as order) {
  <h3>{{ 'aimo.orderconfirmation.thankyou' | cxTranslate }}</h3>
  @for (entry of order.entries; track entry.entryNumber; let idx = $index) {
    <aimo-cart-item [alreadyOrdered]="true" [entry]="entry" [cart]="order"></aimo-cart-item>
  }
}
